import React, { useCallback } from "react";

const Breadcrumb = ({ breadcrumbs, hashedCompanyId = null }) => {
  const BreadcrumbList = useCallback(
    () =>
      breadcrumbs.map((item, index) => {
        if (item.uri) {
          return (
            <li
              className="breadcrumb-item breadcrumb-item--pattern text-fz-14px"
              key={index}
            >
              <a href={hashedCompanyId ? '/community/' + hashedCompanyId + item.uri : item.uri} className="breadcrumb-item__link">
                {item.name}
              </a>
            </li>
          );
        } else {
          return (
            <li
              className="breadcrumb-item breadcrumb-item--pattern text-fz-14px"
              key={index}
            >
              {item.name}
            </li>
          );
        }
      }),
    [breadcrumbs]
  );

  return (
    <div>
      <nav aria-label="breadcrumb" className="breadcrumb">
        <ul className="mb-0 rounded-0 breadcrumb--scroll container px-0 col-lg-8">
          <li className="breadcrumb-item breadcrumb-item--pattern text-fz-14px">
            <a href={hashedCompanyId ? '/community/' + hashedCompanyId : '/'} className="breadcrumb-item__link">
              ホーム
            </a>
          </li>
          <BreadcrumbList />
        </ul>
      </nav>
    </div>
  );
};

export default Breadcrumb;
